// Mirror of `fractionalSetPoints` in @tournament-suite/parsers — the viewer is a
// standalone CRA app and cannot import workspace packages, so the classification
// rule lives here in duplicate. Keep both in sync.
export interface FractionalPoints {
  side1: number;
  side2: number;
}

export function fractionalSetPoints(score1: number, score2: number): FractionalPoints {
  if (score1 === score2) {
    return { side1: 1, side2: 1 };
  }

  const isSide1Winner = score1 > score2;
  const winnerScore = isSide1Winner ? score1 : score2;
  const margin = Math.abs(score1 - score2);

  const isDominantWin =
    (winnerScore >= 21 && margin > 6) || (winnerScore === 15 && margin > 5);

  if (isDominantWin) {
    return isSide1Winner ? { side1: 3, side2: 0 } : { side1: 0, side2: 3 };
  }

  return isSide1Winner ? { side1: 2, side2: 1 } : { side1: 1, side2: 2 };
}

export function fractionalMatchPoints(setScores: string[]): FractionalPoints {
  let side1 = 0;
  let side2 = 0;

  for (const setScore of setScores) {
    const [score1, score2] = String(setScore).split(":").map((n) => parseInt(n, 10));

    if (Number.isNaN(score1) || Number.isNaN(score2)) {
      continue;
    }

    const points = fractionalSetPoints(score1, score2);
    side1 += points.side1;
    side2 += points.side2;
  }

  return { side1, side2 };
}

export function isFractionalLabel(label: string | null | undefined): boolean {
  return /FRACTIONAL/i.test(label ?? "");
}
